(function () {
  var STORAGE_KEY = 'stitch_exit_shown';
  var MIN_DELAY = 5000;
  var ready = false;
  var shown = false;

  function shouldSkip() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return true;
    } catch (e) {}
    if (window.location.pathname.indexOf('/checkout') === 0) return true;
    if (window.location.pathname.indexOf('/cart') === 0) return true;
    return false;
  }

  function markShown() {
    shown = true;
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function showPopup() {
    if (shown || shouldSkip()) return;
    markShown();
    var el = document.getElementById('stitch-exit-popup');
    if (el) el.classList.add('stitch-exit-popup--visible');
  }

  function hidePopup() {
    var el = document.getElementById('stitch-exit-popup');
    if (el) el.classList.remove('stitch-exit-popup--visible');
  }

  function initPopup() {
    var popup = document.getElementById('stitch-exit-popup');
    if (!popup) return;

    popup.addEventListener('click', function (e) {
      if (e.target === popup) hidePopup();
    });

    var closeBtn = popup.querySelector('.stitch-exit-popup__close');
    if (closeBtn) closeBtn.addEventListener('click', hidePopup);

    var form = popup.querySelector('.stitch-exit-popup__form');
    var input = popup.querySelector('.stitch-exit-popup__input');
    var btn = popup.querySelector('.stitch-exit-popup__btn');
    var msg = popup.querySelector('.stitch-exit-popup__msg');

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = input ? input.value.trim() : '';
        if (!email || email.indexOf('@') < 1) return;
        if (btn) btn.disabled = true;
        form.style.display = 'none';
        if (msg) msg.style.display = 'block';
      });
    }
  }

  function initExitIntent() {
    setTimeout(function () { ready = true; }, MIN_DELAY);

    document.addEventListener('mouseleave', function (e) {
      if (!ready || shown) return;
      if (e.clientY < 5) showPopup();
    });

    var lastScrollY = window.scrollY;
    var lastScrollTime = Date.now();
    var hasScrolledFar = false;
    window.addEventListener('scroll', function () {
      var now = Date.now();
      var delta = lastScrollY - window.scrollY;
      var dt = now - lastScrollTime;
      lastScrollY = window.scrollY;
      lastScrollTime = now;
      if (window.scrollY > document.body.scrollHeight * 0.4) hasScrolledFar = true;
      if (!ready || shown) return;
      if (hasScrolledFar && window.scrollY < 80 && delta > 40 && dt < 300) showPopup();
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (shouldSkip()) return;
    initPopup();
    initExitIntent();
  });
})();
